/**
 * TimePeriodFilter - Reusable time period selector
 */

const TIME_PERIODS = [
  { code: 'OVERALL_BEST', name: 'All Time' },
  { code: 'TOP_OF_YEAR', name: 'This Year' },
  { code: 'TOP_OF_MONTH', name: 'This Month' },
  { code: 'TOP_OF_WEEK', name: 'This Week' }
]

const TimePeriodFilter = ({
  selectedPeriod,
  onPeriodChange,
  periods = TIME_PERIODS,
  className = ''
}) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <span className="text-sm text-gray-600 dark:text-gray-400 whitespace-nowrap">Time:</span>
      <div className="flex gap-1 flex-wrap">
        {periods.map((period) => (
          <button
            key={period.code}
            onClick={() => onPeriodChange(period.code)}
            className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${
              selectedPeriod === period.code
                ? 'bg-primary-600 text-white'
                : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600'
            }`}
          >
            {period.name}
          </button>
        ))}
      </div>
    </div>
  )
}

export { TIME_PERIODS }
export default TimePeriodFilter
